export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informace o protistraně"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Účet / E-mail / Telefon"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Krypto-adresa / E-mail / Telefon"])}
}